// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4cd860a8","488":"5dc00adb","732":"3a063a13","977":"aab6afa5"}[chunkId] + ".chunk.js";
};